const routes = {
  '/app/two-factor-setup': {
    fetch: () =>
      import(
        /* webpackChunkName: 'two-factor-route' */ 'app/two-factor/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
